import { render, staticRenderFns } from "./WorkerContractDataTab.vue?vue&type=template&id=2854dc44&"
import script from "./WorkerContractDataTab.vue?vue&type=script&lang=js&"
export * from "./WorkerContractDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports